import './skillsItem.scss';
import { useState } from 'react';

function SkillsItem(props) {
  const [display1, setDisplay1] = useState('block');
  const [display2, setDisplay2] = useState('none');

  function hoverOnItem(hover) {
    if (hover) {
      setDisplay1('none');
      setDisplay2('block');
    }
    else if (!hover) {
      setDisplay1('block');
      setDisplay2('none');
    }
  }


  return (
    <div className='skillsItem'>
      <div style={{ display: `${display1}` }} className='skillsItem__img' onMouseEnter={() => hoverOnItem(true)}>
        <img src={props.img} alt={props.alt}></img>
      </div>
      <div style={{ display: `${display2}` }} className='skillsItem__info' onMouseLeave={() => hoverOnItem(false)}>
        <h3 className='skillsItem__info__header'> {props.header} </h3>
      </div>
    </div>
  );
}

export default SkillsItem;